import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import {
  Form,
  Button,
  Navbar,
  Container,
  Card,
  ListGroup,
  Row,
  Modal,
  Col,
  InputGroup,
} from "react-bootstrap";
import Swal from "sweetalert2";
import { HighlightOffRounded } from "@mui/icons-material";
import { Print, Search } from "@mui/icons-material";
import "./activity_inside.css";
import SwiperCore, { Pagination, Navigation } from "swiper";
import { Pagination as MuiPagination } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import "swiper/css/navigation";
import config from "../../assets/api/config";
import Loader from "../../components/Loader";
import logo from "../../assets/logo.webp";
SwiperCore.use([Pagination, Navigation]);

const Activity_Inside = () => {
  const [activityYear, setActivityYear] = useState("");
  const [semesterOptions, setSemesterOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [countInside, setCountInside] = useState({});
  const [teacherForm, setTeacherForm] = useState([]);
  const [selectedActivity, setSelectedActivity] = useState(null);
  const [editValue, setEditValue] = useState("");
  const [showEditModal, setShowEditModal] = useState(false);
  const [activityYearExcel, setActivityYearExcel] = useState(null);
  const [facultyList, setFacultyList] = useState([]);
  const [institution, setInstitution] = useState([]);
  const [searchQuery, setSearchQuery] = useState({
    activityYear: "",
    department: "",
  });
  const [isActive, setIsActive] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [showExportModal, setShowExportModal] = useState(false);

  const queryParams = new URLSearchParams(location.search);
  const ciphertext = queryParams.get("q");
  const hostName = config.hostName;
  const itemsPerPageDesktop = 9; // Number of items to display per page on desktop
  const itemsPerPageMobile = 4;
  const [itemsPerPage, setItemsPerPage] = useState(itemsPerPageDesktop);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/");
      return;
    }
  }, []);

  useEffect(() => {
    fetch(`${hostName}/activity_counts`)
      .then((response) => response.json())
      .then((data) => {
        setCountInside(data);
      });
  }, []);

  useEffect(() => {
    fetch(`https://i.vu.ac.th/php_api/faculty_api?factype=1`)
      .then((response) => response.json())
      .then((data) => {
        setFacultyList(data);
      })
      .catch((error) => console.error(error));
  }, []);

  useEffect(() => {
    fetch(`https://i.vu.ac.th/php_api/faculty_api?factype=0`)
      .then((response) => response.json())
      .then((data) => {
        setInstitution(data);
      })
      .catch((error) => console.error(error));
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setItemsPerPage(itemsPerPageMobile); // Use 3 items on mobile
      } else {
        setItemsPerPage(itemsPerPageDesktop); // Use 9 items on desktop
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `https://i.vu.ac.th/research_api/semester-year`
        ); // Update the URL accordingly
        const data = await response.json();
        setSemesterOptions(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const goBackToFirstPage = () => {
    if (ciphertext) {
      const encodedCiphertext = encodeURIComponent(ciphertext);
      navigate(`/approver_dashboard?q=${encodedCiphertext}`);
    } else {
      // Handle the case when the ciphertext is null or not available
      console.error("Invalid ciphertext");
    }
  };

  async function handleButtonClick(status, t_id) {
    if (status === "ผ่าน") {
      const result = await Swal.fire({
        title: "ยืนยัน",
        text: "อนุมัติกิจกรรมนี้ผ่านใช่หรือไม่",
        icon: "warning",
        customClass: {
          title: "thai-font",
          header: "thai-font",
          popup: "thai-font text-sweet",
        },

        showCancelButton: true,
        confirmButtonColor: "green",
        cancelButtonColor: "gray",
        confirmButtonText: "ใช่",
        cancelButtonText: "ปิด",
      });
      if (result.isConfirmed) {
        const updatedActivity = {
          ...selectedActivity,
          check_activity: status,
        };

        fetch(`${hostName}/update-teacher-form`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ t_id, status }),
        }).then((response) => {
          if (response.ok) {
            setSelectedActivity(updatedActivity);
            setTeacherForm((prevState) =>
              prevState.map((activity) =>
                activity.t_id === selectedActivity.t_id
                  ? updatedActivity
                  : activity
              )
            );

            Swal.fire({
              icon: "success",
              title: "อนุมัติกิจกรรมสำเร็จ",
              showConfirmButton: false,
              timer: 1500,
              customClass: {
                title: "thai-font",
              },
            });
            setSelectedActivity(null);
          } else {
            console.error("Error submitting form");
            Swal.fire({
              icon: "error",
              text: "ระบบไม่สามารถอนุมัติได้",
            });
          }
        });
      }
    } else if (status === "แก้ไข") {
      setShowEditModal(true);
    }
  }

  function handleEditSubmit() {
    const updatedActivity = {
      ...selectedActivity,
      check_activity: editValue,
    };

    fetch(`${hostName}/update-teacher-form`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        t_id: selectedActivity.t_id,
        check_activity: editValue,
        status: "แก้ไข",
      }),
    }).then((response) => {
      setSelectedActivity(updatedActivity);
      setTeacherForm((prevState) =>
        prevState.map((activity) =>
          activity.t_id === selectedActivity.t_id ? updatedActivity : activity
        )
      );

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "บันทึกเหตุผลแก้ไขสำเร็จ",
          showConfirmButton: false,
          timer: 1500,
          customClass: {
            title: "thai-font",
          },
        });
        setSelectedActivity(updatedActivity);
        setShowEditModal(false);
        setEditValue("");
      } else {
        console.error("Error submitting form");
        Swal.fire({
          icon: "error",
          text: "ระบบไม่สามารถบันทึกเหตุผลแก้ไขได้",
        });
      }
    });
  }

  const handleShowModal = (activity) => {
    setSelectedActivity(activity);
  };

  function toggleSidebar() {
    const sidebar = document.querySelector(".sidebar");
    const icon = document.querySelector(".navbar-toggler-icon");

    sidebar.classList.toggle("active");
    icon.classList.toggle("open");
  }

  const handleSearchChange = (e) => {
    const { name, value } = e.target;
    let parsedValue = value;

    // Check if the value is a JSON string and parse it if so
    try {
      parsedValue = JSON.parse(value);
    } catch (error) {
      // Handle parsing error if necessary
    }

    setSearchQuery({
      ...searchQuery,
      [name]: parsedValue,
    });
  };

  const handleActiveClick = () => {
    setIsActive(!isActive);
  };

  const handleSearchSubmit = () => {
    setLoading(true);
    // Construct the query parameters based on the selected values
    let queryParams = "";
    if (searchQuery.activityYear) {
      queryParams += `activity_year=${searchQuery.activityYear}&`;
    }
    if (searchQuery.department) {
      queryParams += `department=${searchQuery.department}&`;
    }
    if (searchQuery.institution) {
      queryParams += `institution=${searchQuery.institution}&`;
    }
    if (!isActive) {
      queryParams += `waitCheck=true&`;
    } else {
      queryParams += `alreadyCheck=true&`;
    }

    // Remove trailing '&' character if any
    if (queryParams.endsWith("&")) {
      queryParams = queryParams.slice(0, -1);
    }

    // Construct the URL with the query parameters
    const url = `${hostName}/teacher_form_check/?${queryParams}`;

    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        data.sort((a, b) => b.t_id - a.t_id);
        // Process the search results
        if (data.length === 0) {
          setTeacherForm(0); // Set teacherForm to 0 to indicate no data available
        } else {
          setTeacherForm(data);
        }
        setLoading(false);
        setCurrentPage(1);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  };

  const handleShowExport = () => {
    setShowExportModal(true);
  };

  const handleExportActivityToExcel = async () => {
    if (!activityYearExcel) {
      console.error("Error submitting form");
      Swal.fire({
        icon: "error",
        text: "กรุณาเลือกปีการศึกษาที่ต้องการพิมพ์รายงาน",
      });
    } else {
      try {
        const response = await fetch(
          `${hostName}/export-activity-to-excel?activityYearExcel=${activityYearExcel}`
        );
        if (response.ok) {
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = "กิจกรรมภายใน.xlsx";
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        } else {
          throw new Error("Export failed");
        }
      } catch (error) {
        console.error(error);
        Swal.fire({
          icon: "error",
          text: "เกิดข้อผิดพลาดในการส่งคำร้องขอพิมพ์รายงาน",
        });
      }
    }
  };

  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const visibleItems = Array.isArray(teacherForm)
    ? teacherForm.slice(startIndex, endIndex)
    : [];

  return (
    <>
      <div>
        <div className="navbar-parent-container">
          <Navbar
            expand="lg"
            variant="light"
            style={{
              backgroundColor: "#EFC001",
              height: "60px",
              width: "100vw",
            }}
            fluid="true"
            className="navbar"
          >
            <Container className="navbar_container" fluid>
              <Navbar.Brand>
                <button
                  className="navbar-toggler"
                  type="button"
                  onClick={toggleSidebar}
                >
                  <span className="navbar-toggler-icon"></span>
                </button>
                <img
                  alt=""
                  src={logo}
                  style={{ width: 40, height: 40 }}
                  className="d-inline-block align-top"
                />{" "}
                <span
                  className="thai-font"
                  style={{ fontWeight: "bold", color: "black" }}
                >
                  VU Volunteer Checker
                </span>
              </Navbar.Brand>
            </Container>
          </Navbar>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <div className="sidebar">
                {" "}
                <p
                  className="thai-font"
                  style={{
                    fontSize: 24,
                    fontWeight: "bold",
                    borderBottom: "1px solid black",
                  }}
                >
                  กิจกรรมจัดขึ้นโดยคณะ ศูนย์ สำนักของมหาวิทยาลัย
                </p>
                <ul
                  className="list-unstyled thai-font"
                  style={{ fontSize: 22 }}
                >
                  <li
                    style={{ cursor: "pointer" }}
                    onClick={() => goBackToFirstPage(ciphertext)}
                  >
                    <Link to={() => goBackToFirstPage(ciphertext)}>
                      หน้าแรก
                    </Link>
                  </li>
                  <li
                    className={
                      location.pathname === "/activity_inside" ? "active" : ""
                    }
                  >
                    <Link
                      to={`/activity_inside?q=${encodeURIComponent(
                        ciphertext
                      )}`}
                    >
                      อนุมัติกิจกรรม{" "}
                      {countInside.teacherFormNumber !== 0 && (
                        <span style={{ color: "red", fontWeight: "bold" }}>
                          ({countInside.teacherFormNumber})
                        </span>
                      )}
                    </Link>
                  </li>
                  <li
                    className={
                      location.pathname === "/check_activity_inside"
                        ? "active"
                        : ""
                    }
                  >
                    <Link
                      to={`/check_activity_inside?q=${encodeURIComponent(
                        ciphertext
                      )}`}
                    >
                      ตรวจสอบกิจกรรมนักศึกษา{" "}
                      {/* {countInside.insideNumber !== 0 && (
                        <span style={{ color: "red", fontWeight: "bold" }}>
                          ({countInside.insideNumber})
                        </span>
                      )} */}
                    </Link>
                  </li>
                  <li
                    className={
                      location.pathname === "/teacher_dashboard" ? "active" : ""
                    }
                  >
                    <Link
                      to={`/teacher_dashboard?q=${encodeURIComponent(
                        ciphertext
                      )}`}
                    >
                      เพิ่มข้อมูลกิจกรรมที่จัดขึ้นโดยคณะ ศูนย์ สำนัก{" "}
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <h1
          style={{
            textAlign: "center",
            marginTop: 80,
            fontSize: 35,
            fontWeight: "bold",
          }}
          className="thai-font approve-container"
        >
          อนุมัติกิจกรรม
        </h1>
        <div className="content thai-font">
          <div className="search-container">
            <div
              style={{
                maxWidth: "650px",
                padding: "20px",
                border: "1px solid #ccc",
                borderRadius: "25px",
                marginTop: "20px",
                margin: "0 auto",
              }}
            >
              <Form>
                <Row className="mb-3">
                  <Col>
                    <Form.Label>ปีการศึกษา/ภาคเรียน</Form.Label>
                    <Form.Control
                      as="select"
                      name="activityYear"
                      placeholder="Activity Year"
                      value={searchQuery.activityYear}
                      onChange={handleSearchChange}
                    >
                      {semesterOptions.map((semester) => (
                        <option
                          key={semester.Sem_ID}
                          value={semester.Formatted_Sem}
                        >
                          {semester.Formatted_Sem}
                        </option>
                      ))}
                    </Form.Control>
                  </Col>
                  <Col xs={12} md={4}>
                    <Form.Group controlId="department">
                      <Form.Label>คณะวิชา</Form.Label>
                      <Form.Control
                        as="select"
                        name="department" // Update the name attribute to a unique value
                        value={searchQuery.department}
                        onChange={handleSearchChange}
                      >
                        <option value="">-- เลือก --</option>
                        {facultyList.map((faculty) => (
                          <option value={faculty.Fac_ID} key={faculty.Fac_ID}>
                            {faculty.Fac_NameTH}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={4}>
                    <Form.Group controlId="institution">
                      <Form.Label>ศูนย์/สำนัก</Form.Label>
                      <Form.Control
                        as="select"
                        name="institution" // Update the name attribute to a unique value
                        onChange={handleSearchChange}
                        value={searchQuery.institution}
                      >
                        <option value="">-- เลือก --</option>
                        {institution.map((inst) => (
                          <option value={inst.Fac_ID} key={inst.Fac_ID}>
                            {inst.Fac_NameTH}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Button
                  style={{
                    padding: "5px 10px",
                    borderRadius: "5px",
                    border: isActive ? "1px solid orange" : "none", // Add border for non-active button
                    backgroundColor: isActive ? "white" : "orange",
                    color: isActive ? "black" : "white",
                    width: "150px",
                    fontSize: "20px",
                  }}
                  className="btn btn-warning"
                  onClick={handleActiveClick}
                >
                  รอการตรวจสอบ
                </Button>

                <Button
                  className="btn btn-success"
                  style={{
                    padding: "5px 10px",
                    borderRadius: "5px",
                    marginRight: "10px",
                    border: !isActive ? "1px solid green" : "none", // Add border for non-active button
                    backgroundColor: isActive ? "green" : "white",
                    color: isActive ? "white" : "black",
                    width: "150px",
                    fontSize: "20px",
                  }}
                  onClick={handleActiveClick}
                >
                  ตรวจสอบแล้ว
                </Button>

                <Button
                  className="btn btn-success thai-font"
                  style={{ fontSize: 18 }}
                  onClick={() => handleShowExport()}
                >
                  <Print /> พิมพ์รายงาน
                </Button>
              </div>
              <Row className="mb-3 justify-content-end mt-3">
                <Col xs={12} md={4}>
                  <Button
                    onClick={() => handleSearchSubmit()}
                    variant="primary"
                    style={{ fontSize: "22px" }}
                  >
                    <Search /> ค้นหา
                  </Button>
                </Col>
              </Row>
            </div>
          </div>
          <div className="card-item">
            {teacherForm === 0 ? (
              <p style={{ color: "red" }}>***ไม่มีข้อมูลกิจกรรม***</p>
            ) : (
              <ListGroup>
                <Row
                  className="justify-content-center"
                  style={{ height: "auto" }}
                >
                  {visibleItems.map((activity, index) => (
                    <Card
                      key={activity.t_id}
                      className="activity-card thai-font"
                      style={{ fontSize: 20, height: "auto" }}
                    >
                      <Swiper
                        navigation={true}
                        pagination={{ clickable: true }}
                        paginationstyle={{ marginBottom: 20 }}
                      >
                        {activity.picture_data.map((picture, index) => (
                          <SwiperSlide key={index}>
                            {picture ? (
                              <Card.Img
                                variant="top"
                                src={`data:image/png;base64,${picture}`}
                                className="card-img-top"
                                style={{ height: 300 }}
                              />
                            ) : (
                              <Card.Img
                                variant="top"
                                src={logo}
                                className="card-img-top"
                                style={{ height: 300 }}
                              />
                            )}
                          </SwiperSlide>
                        ))}
                      </Swiper>

                      <Card.Header
                        style={{
                          fontWeight: "bold",
                          backgroundColor: "#E7E7E7",
                        }}
                      >
                        {activity.activity_name}
                      </Card.Header>
                      <ListGroup.Item>
                        <strong>ภาคเรียน:</strong> {activity.activity_year}
                      </ListGroup.Item>
                      <ListGroup.Item>
                        <strong>วันที่จัดกิจกรรม:</strong>{" "}
                        {new Date(activity.activity_date).toLocaleDateString(
                          "th-TH",
                          {
                            year: "numeric",
                            month: "short",
                            day: "numeric",
                          }
                        )}
                      </ListGroup.Item>
                      <ListGroup.Item>
                        <strong>วันที่สิ้นสุดกิจกรรม:</strong>{" "}
                        {new Date(activity.last_date).toLocaleDateString(
                          "th-TH",
                          {
                            year: "numeric",
                            month: "short",
                            day: "numeric",
                          }
                        )}
                      </ListGroup.Item>
                      <ListGroup.Item>
                        <strong>ผู้ดูแลกิจกรรม:</strong> {activity.teacher_name}
                      </ListGroup.Item>

                      <ListGroup.Item>
                        <strong>กิจกรรมจัดขึ้นโดย:</strong>{" "}
                        {activity.department &&
                          JSON.parse(activity.department).dep_name}
                      </ListGroup.Item>

                      <ListGroup.Item className="text-center">
                        {activity && (
                          <button
                            className={`btn ${
                              activity.check_activity === "ผ่าน"
                                ? "btn-success"
                                : activity.check_activity
                                ? "btn-warning"
                                : "btn-primary"
                            }`}
                            onClick={() => handleShowModal(activity)}
                            style={{
                              fontSize: 20,
                              color: "white",
                            }}
                          >
                            {activity.check_activity
                              ? activity.check_activity === "ผ่าน"
                                ? "ผ่าน"
                                : "แก้ไข"
                              : "ดูข้อมูลกิจกรรม"}
                          </button>
                        )}
                      </ListGroup.Item>
                    </Card>
                  ))}
                </Row>
              </ListGroup>
            )}
          </div>

          {visibleItems.length > 0 && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "20px",
                marginLeft: "18%",
              }}
            >
              <MuiPagination
                count={Math.ceil(teacherForm.length / itemsPerPage)}
                page={currentPage}
                onChange={handlePageChange}
                color="warning"
              />
            </div>
          )}

          <Modal
            show={selectedActivity !== null}
            onHide={() => {
              setSelectedActivity(null);
            }}
            className="thai-font"
            style={{ fontSize: 20, zIndex: 10000 }}
          >
            <div style={{ position: "relative" }}>
              <button
                className="btn btn-light"
                style={{ position: "absolute", top: 0, right: 0, fontSize: 20 }}
                onClick={() => {
                  setSelectedActivity(null);
                }}
              >
                <HighlightOffRounded style={{ color: "red" }} />
              </button>

              <Swiper
                navigation={true}
                pagination={{ clickable: true }}
                paginationstyle={{ marginBottom: 20 }}
              >
                {selectedActivity?.picture_data.map((picture, index) => (
                  <SwiperSlide key={index}>
                    {picture ? (
                      <img
                        variant="top"
                        src={`data:image/png;base64,${picture}`}
                        className="img-fluid"
                        style={{ width: 500, height: 600 }}
                      />
                    ) : (
                      <img
                        src={logo}
                        variant="top"
                        className="img-fluid"
                        style={{ width: 500 }}
                      />
                    )}
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>

            <Modal.Title
              style={{ fontWeight: "bold", marginTop: 10, marginLeft: 10 }}
            >
              {selectedActivity?.activity_name}
            </Modal.Title>
            <hr />
            <Modal.Body>
              <p>
                <strong>ภาคเรียน:</strong> {selectedActivity?.activity_year}
              </p>
              <p>
                <strong>วันที่จัดกิจกรรม:</strong>{" "}
                {new Date(selectedActivity?.activity_date).toLocaleDateString(
                  "th-TH",
                  { year: "numeric", month: "short", day: "numeric" }
                )}
              </p>
              <p>
                <strong>วันที่สิ้นสุดกิจกรรม:</strong>{" "}
                {new Date(selectedActivity?.last_date).toLocaleDateString(
                  "th-TH",
                  {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                  }
                )}
              </p>
              <p>
                <strong>สถานที่จัดกิจกรรม:</strong>{" "}
                {selectedActivity?.activity_place}
              </p>
              <p>
                <strong>ผู้ดูแลกิจกรรม:</strong>{" "}
                {selectedActivity?.teacher_name}
              </p>
              <p>
                <strong>กิจกรรมจัดขึ้นโดย:</strong>{" "}
                {selectedActivity?.department &&
                  JSON.parse(selectedActivity?.department).dep_name}
              </p>
              <p>
                <strong>สร้างกิจกรรมเมื่อวันที่:</strong>{" "}
                {new Date(selectedActivity?.create_time).toLocaleString(
                  "th-TH",
                  {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                    hour: "numeric",
                    minute: "numeric",
                    second: "numeric",
                    timeZone: "UTC",
                  }
                )}
              </p>
              <strong
                style={{
                  color: "red",
                  display:
                    selectedActivity?.check_activity === "ผ่าน" ||
                    !selectedActivity?.check_activity
                      ? "none"
                      : "inline",
                }}
              >
                เหตุผลที่ต้องแก้ไข:
              </strong>{" "}
              {selectedActivity?.check_activity === "ผ่าน"
                ? null
                : selectedActivity?.check_activity}
            </Modal.Body>
            <Modal.Footer
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div>
                <Button
                  onClick={() =>
                    handleButtonClick("ผ่าน", selectedActivity.t_id)
                  }
                  variant="success"
                  style={{ fontSize: 20, marginRight: 20 }}
                >
                  ผ่าน
                </Button>
                <Button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleButtonClick("แก้ไข", selectedActivity.t_id);
                  }}
                  variant="warning"
                  style={{ fontSize: 20, marginRight: 20 }}
                >
                  แก้ไข
                </Button>
                <Button
                  onClick={() => {
                    setSelectedActivity(null);
                  }}
                  className="btn btn-secondary"
                  style={{ fontSize: 20, marginRight: 20 }}
                >
                  ปิด
                </Button>

                {showEditModal && (
                  <Modal
                    show={showEditModal}
                    onHide={() => {
                      setShowEditModal(false);
                      setEditValue("");
                    }}
                    centered
                    className="thai-font modal-dialog-centered"
                    size="lg"
                    style={{ zIndex: 999999 }}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title style={{ fontWeight: "bold" }}>
                        เหตุผลที่ต้องแก้ไข
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        placeholder="ระบุเหตุผลที่ต้องการแก้ไข"
                        value={editValue}
                        onChange={(e) => setEditValue(e.target.value)}
                      />
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        variant="secondary"
                        onClick={() => {
                          setEditValue("");
                          setShowEditModal(false);
                        }}
                        style={{ fontSize: 20 }}
                      >
                        ยกเลิก
                      </Button>
                      <Button
                        variant="primary"
                        onClick={() => handleEditSubmit()}
                        style={{ fontSize: 20 }}
                      >
                        บันทึก
                      </Button>
                    </Modal.Footer>
                  </Modal>
                )}
              </div>
            </Modal.Footer>
          </Modal>
        </div>
        <div>
          {showExportModal && (
            <Modal
              show={showExportModal}
              onHide={() => {
                setShowExportModal(false);
                setActivityYearExcel(null);
              }}
              className="thai-font"
            >
              <Modal.Title
                style={{ fontWeight: "bold", fontSize: 30, marginLeft: 10 }}
              >
                พิมพ์รายงานกิจกรรมโดยคณะวิชา ศูนย์ สำนัก
              </Modal.Title>
              <hr />
              <Modal.Body>
                <Form>
                  <Form.Label>ปีการศึกษา/ภาคเรียน</Form.Label>
                  <Form.Control
                    as="select"
                    name="activity_year"
                    placeholder="Activity Year"
                    value={activityYearExcel}
                    onChange={(e) => setActivityYearExcel(e.target.value)}
                  >
                    <option value="">--เลือก--</option>
                    {semesterOptions.map((semester) => (
                      <option
                        key={semester.Sem_ID}
                        value={semester.Formatted_Sem}
                      >
                        {semester.Formatted_Sem}
                      </option>
                    ))}
                  </Form.Control>
                </Form>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="btn btn-success"
                  onClick={() => handleExportActivityToExcel()}
                >
                  พิมพ์รายงาน
                </Button>
                <Button
                  className="btn btn-secondary"
                  onClick={() => {
                    setShowExportModal(false);
                    setActivityYearExcel(null);
                  }}
                >
                  ปิด
                </Button>
              </Modal.Footer>
            </Modal>
          )}
        </div>
        {loading && (
          <div>
            <Loader className="thai-font" />
          </div>
        )}{" "}
      </div>
    </>
  );
};

export default Activity_Inside;
